import React, { Component } from 'react';

class Accordion extends Component {
  render () {
    return (
      <div className="accordion">
        <input type="checkbox" name="accordion__check" id="accordion__bar" className="accordion__bar" />
        <label htmlFor="accordion__bar" className="accordion__label">{this.props.title}</label>
          {this.props.children}
      </div>
    );
  }
}

export default Accordion;